import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  useEffect(() => {
    document.title = 'Adgang nægtet - Stausbroe Bowen Terapi';
  }, []);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-beige px-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-500 mb-6 border border-red-100">
        <i className="fa-light fa-lock text-2xl" />
      </div>
      <h1 className="font-serif text-4xl font-bold text-brand-neutral-dark md:text-5xl">403</h1>
      <h2 className="mt-2 font-serif text-xl font-semibold text-brand-neutral-dark md:text-2xl">Adgang nægtet</h2>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-brand-neutral-dark/80">
        Du har ikke tilladelse til at se denne side eller ressource. Hvis du mener, dette er en fejl, er du velkommen til at kontakte mig.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-brand-sage px-6 py-2.5 text-sm font-medium text-white shadow-sm transition-all duration-300 hover:bg-brand-sage-dark"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="inline-flex items-center justify-center rounded-full border border-brand-sage-medium/30 bg-white/40 px-6 py-2.5 text-sm font-medium text-brand-neutral-dark transition-all duration-300 hover:bg-white/80"
        >
          Kontakt mig
        </Link>
      </div>
    </div>
  );
}
